/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */



export default {
  //Files:  Files Requiered per Client and businessLine
  //Files:  Files Commons per Client and businessLine
  requieredFiles: (state) => (customer) => {
    const files= state.allocationfiles.filter((item) => {
      let aux = item.customerId === customer
      return aux
    })
    return files
  },
  typeFilesPerBusinessLine:(state) => (businessLine) => {
    const filtered=state.filetype.filter((item)=> {
      let buffer = item.business_line.business_line_id === businessLine
      return buffer
    })
    return filtered
  },
  //Supplys
  filterSubFamily: (state) => (idFamily) => {
    const temp=state['services/subfamilies'].filter( (item)=> {
      return item.family == idFamily
    })
    return temp
  },

  filterSupply: (state) => (idSubFamily,typeS) => {
    const temp=state['services/supplies'].filter( (item)=> {
      if(typeS == -1)
        return (item.subFamilyId == idSubFamily)
      else
        return (item.subFamilyId == idSubFamily) && (item.supplyTypeId == typeS)
    })
    return temp
  },

    filterSupplyHighway: (state) => (idSubFamily,typeS) => {
    const temp=state['supplycamp'].filter( (item)=> {
      if(typeS == -1)
        return (item.sSupplySubFamilyId == idSubFamily)
      else
        return (item.sSupplySubFamilyId == idSubFamily) && (item.sSupplySupplyTypeId == typeS)
    })
    return temp
  },

  businessCycleStatuses: (state) => (businessCycle, businessLine='Carreteras') => {
    return state[`macro/${businessLine}/status`].filter(status => {
      return status.business_cicle == businessCycle.id
    })
  },

  statusProcesses: (state) => (status, businessLine='Carreteras') => {
    return state[`macro/${businessLine}/process`].filter(process => {
      return process.macro_status == status.id
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/catalogs/getters.js